module.exports = __webpack_public_path__ + "static/media/contact.296a0b63.jpg";